import { makeStyles } from '@material-ui/core'

const uesStyles = makeStyles((theme) => ({
  tableheader: {
    display: 'grid',
    gridTemplateColumns: '4fr 8fr 2fr',
    backgroundColor: theme.palette.grey[300],
    padding: 8,
    borderRadius: 4
  },
  paper: {
    margin: 'auto',
    width: '60%',
    maxWidth: 800,
    padding: 24,
    marginTop: '20vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  circularProgress: {
    marginLeft: 8
  },
  CardMembershipIcon: {
    margin: 'auto',
    fontSize: 80,
    position: 'absolute',
    backgroundColor: '#7F7F7F',
    padding: 10,
    borderRadius: '50%',
    top: -42,
    left: 'calc(50% - 40px)'
  },
  title: {
    marginTop: 25,
    textAlign: 'center',
    marginBottom: 24,
    color: theme.palette.text.secondary
  },
  buttonStyle: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  cancelButton: {
    marginRight: 8
  },
  formContainer: {
    // display: 'grid',
    // gridTemplateColumns: '1fr 1fr',
    // gap: 30,
    // alignItems: 'center'
  },
  dataAndTimePickerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  timePicker: {
    marginTop: 25,
    width: '100%'
  },
  timePickerForMobile: {
    marginTop: 0
  }
}))
export default uesStyles
